import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {MatSnackBar} from '@angular/material';
import {MatDialogRef} from '@angular/material/dialog';
import {throwError} from 'rxjs';
import {catchError, filter, switchMap, tap} from 'rxjs/operators';
import {BaseDialog} from '../../../base-dialog';
import {ProfileAddressApiService} from '../../../services/api/profile-address.service';
import {CustomerService} from '../../../services/customer.service';
import {OrderService} from '../../../services/order.service';
import * as moment from 'moment';
import {ProfilePickupService} from '../../../services/profile/profile-pickup.service';
import {PerfilService} from '../../../services/ajs-perfil.service';

@Component({
  selector: 'mandae-pickup-form',
  templateUrl: './collection-settings-form.component.html',
  styleUrls: ['./collection-settings-form.component.scss']
})
export class CollectionSettingsFormComponent extends BaseDialog<CollectionSettingsFormComponent> implements OnInit {

  public weekDays = [
    {value: 1, label: 'Segunda-feira'},
    {value: 2, label: 'Terça-feira'},
    {value: 3, label: 'Quarta-feira'},
    {value: 4, label: 'Quinta-feira'},
    {value: 5, label: 'Sexta-feira'},
  ];

  public step = 'introduction';
  public scheduleForm: FormGroup;
  public loading = false;

  constructor(dialogRef: MatDialogRef<CollectionSettingsFormComponent>,
              private profileAddressApiService: ProfileAddressApiService,
              private snackBar: MatSnackBar,
              private customerService: CustomerService,
              private profilePickupService: ProfilePickupService,
              private orderService: OrderService,
              private perfilService: PerfilService,
              ) {
    super(dialogRef);

    this.scheduleForm = new FormGroup({
      workTimeBegin: new FormControl('', [ Validators.required ]),
      workTimeEnd: new FormControl('', [ Validators.required ]),
      exceptionTime: new FormControl(false),
      exceptionDay: new FormControl(null),
      exceptionTimeBegin: new FormControl(null),
      exceptionTimeEnd: new FormControl(null),
      workBreak: new FormControl(false ),
      workBreakBegin: new FormControl(null),
      workBreakEnd: new FormControl(null),
    }, {
      updateOn: 'change'
    });

    this.scheduleForm.controls['exceptionTime'].valueChanges
      .subscribe(value => {
        this.scheduleForm.controls['exceptionDay'].setValidators(value ? [Validators.required] : []);
        this.scheduleForm.controls['exceptionTimeBegin'].setValidators(value ? [Validators.required] : []);
        this.scheduleForm.controls['exceptionTimeEnd'].setValidators(value ? [Validators.required] : []);
      });

    this.scheduleForm.controls['workBreak'].valueChanges
      .subscribe(value => {
        this.scheduleForm.controls['workPauseBegin'].setValidators(value ? [Validators.required] : []);
        this.scheduleForm.controls['workPauseEnd'].setValidators(value ? [Validators.required] : []);
      });
  }

  ngOnInit() {
  }

  showAddressStep() {
    this.step = 'address';
  }

  submitAddress(addressForm) {
    this.loading = true;
    this.orderService.validateArea(addressForm.value.postalCode.replace('-', ''))
    .pipe(
      catchError(() => throwError(new Error('Este endereço não está em nossa área de abrangência para coletas.'))),
      switchMap(() =>
        this.profileAddressApiService.addAddress({
          nome: addressForm.value.name,
          logradouro: addressForm.value.street,
          bairro: addressForm.value.district,
          cep: addressForm.value.postalCode.replace('-', ''),
          cidade: addressForm.value.city,
          numero: addressForm.value.number,
          complemento: addressForm.value.complement,
          uf: addressForm.value.state,
          remetente: addressForm.value.sender,
          areaDedicadaColeta: addressForm.value.collectDedicatedArea,
          coletaHabilitada: true,
          logisticaReversaHabilitada: true,
          devolucaoHabilitada: true,
        })),
      filter(addResponse => !!addResponse),
      switchMap(addResponse => this.profileAddressApiService.updateAddressAsCollectDefault({ addressId: addResponse['id'] })),
      tap(() => this.step = 'schedule'),
    ).subscribe(() => this.loading = false, err => this.treatError(err));
  }

  backToAddress() {
    this.step = 'address';
  }

  confirmSchedule() {
    this.loading = true;
    if (this.scheduleForm.valid) {
      const customerUpdateRequest = {
        coletaAtiva: true,
        formaColeta: 'SobDemanda',
        horariosInicioExpediente: this.processTime(this.scheduleForm.value.workTimeBegin),
        horariosEncerramentoExpediente: this.processTime(this.scheduleForm.value.workTimeEnd)
      };

      if (this.scheduleForm.value.exceptionDay) {
        customerUpdateRequest['horariosInicioExpediente'][this.scheduleForm.value.exceptionDay]
          = this.scheduleForm.value.exceptionTimeBegin;
        customerUpdateRequest['horariosEncerramentoExpediente'][this.scheduleForm.value.exceptionDay]
          = this.scheduleForm.value.exceptionTimeEnd;
      }

      if (this.scheduleForm.value.workBreak) {
        customerUpdateRequest['inicioExpedientePausa'] = this.timeToOffsetTime(this.scheduleForm.value.workBreakBegin);
        customerUpdateRequest['fimExpedientePausa'] = this.timeToOffsetTime(this.scheduleForm.value.workBreakEnd);
      }

      this.profilePickupService.setCustomer(customerUpdateRequest)
        .pipe(switchMap(() => this.customerService.notifyNewCollectionData(this.perfilService.getCacheUserData().id)))
        .subscribe(() => {
          this.step = 'confirm';
          this.loading = false;
        }, err => this.treatError(err));
    }
  }

  private processTime(time) {
    return [1, 2, 3, 4, 5]
      .reduce((acc, d) => {
        acc[d] = time;
        return acc;
      }, {});
  }

  private treatError(err: any) {

    if (err.error && err.error.error) {
      this.snackBar.open(err.error.error.message, 'Fechar');
    } else {
      this.snackBar.open(err.message, 'Fechar');
    }

    this.loading = false;
  }

  private timeToOffsetTime(time: string) {
    return moment(time, ['HH,mm']).format('HH:mmZ');
  }
}
